import { render, staticRenderFns } from "./changeInitPw.vue?vue&type=template&id=630a5308&"
import script from "./changeInitPw.vue?vue&type=script&lang=js&"
export * from "./changeInitPw.vue?vue&type=script&lang=js&"
import style0 from "./changeInitPw.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports